/** True when the app is loaded on the admin subdomain (e.g. admin.myplayercentral.com) */
export const IS_ADMIN_PORTAL = window.location.hostname.startsWith('admin.');
